
import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import SEOHead from '@/components/SEOHead';
import { PrivacyContent } from '@/components/legal/shared/PrivacyContent';

const PrivacyPolicy: React.FC = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Privacy Policy - forkast",
    "description": "Privacy policy detailing data collection, usage, and protection practices for forkast users.",
    "url": "https://forkast.in/privacy",
    "isPartOf": {
      "@type": "WebSite",
      "name": "forkast",
      "url": "https://forkast.in"
    }
  };

  return (
    <>
      <SEOHead 
        title="Privacy Policy - How forkast Protects Your Data"
        description="Learn about how forkast collects, uses, and protects your data. Transparent privacy policy for AI-powered family meal planning."
        jsonLd={jsonLd}
      />
      <PageLayout 
        title="Privacy Policy"
        description="Effective Date: September 4, 2025 • Operated by Sébastien (EU) • Contact: forkast.in.app@gmail.com"
      >
        <div className="max-w-4xl mx-auto prose prose-gray mt-6">
          <PrivacyContent variant="web" />
        </div>
      </PageLayout>
    </>
  );
};

export default PrivacyPolicy;
